import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useAssignmentAlerts } from "@/lib/notifications";
import TopBar from "./TopBar";
import NavRail from "./NavRail";
import MetricsStrip from "./MetricsStrip";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";

export default function Shell() {
  const { user, stopImpersonation } = useAuth();
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  useAssignmentAlerts();
  return (
    <div className="flex h-full flex-col">
      {user.impersonator && (
        <div className="flex items-center gap-3 border-b border-amber-500/50 bg-amber-500/10 px-4 py-1.5 text-xs" data-testid="impersonation-banner">
          <Eye className="h-3.5 w-3.5 text-amber-500" />
          <span>
            Viewing as <strong>{user.name}</strong> ({user.email}) · read-only · you are {user.impersonator.name}
          </span>
          <Button size="sm" variant="outline" className="ml-auto h-6 border-amber-500/60 text-xs" onClick={() => stopImpersonation().then(() => navigate("/users"))} data-testid="exit-impersonation-btn">
            <X className="mr-1 h-3 w-3" /> Exit view-as
          </Button>
        </div>
      )}
      <TopBar onMenu={() => setMenu(true)} />
      <MetricsStrip />
      <div className="flex min-h-0 flex-1">
        <NavRail className="hidden lg:flex" />
        <Sheet open={menu} onOpenChange={setMenu}>
          <SheetContent side="left" className="w-64 bg-card p-0">
            <NavRail onNavigate={() => setMenu(false)} className="w-full border-r-0" />
          </SheetContent>
        </Sheet>
        <main className="min-w-0 flex-1 overflow-auto bg-background">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
